import { $t } from '@/i18n'
import request from "@/utils/request";

/* 订单列表 */
export const fetchSaleOrderList = (params) => {
  return request({
    url: `/order/v1`,
    params,
  });
};

/* 获取订单信息 */
export function getSaleOrderInfo(id) {
  return request({
    url: `/order/${id}/v1`,
  });
}

// 销售订单列表导出
export function exportSaleOrderList(params) {
  return request(
    {
      url: "/export/order/v1",
      params,
    },
    {
      success: true,
      successMsg: `导出成功`,
    }
  );
}

// 当前组织及下组织
export function getOrgAll(params) {
  return request({
    url: "/mct_org/all/v1",
    params,
  });
}

export function shopList(params) {
  return request({
    url: "/shop/v1",
    params,
  });
}

/* 用户禁用启用 */
export function userEnabled(userId, data) {
  return request({
    url: `/order/user/enabled/${userId}/v1`,
    method: "PUT",
    data,
  });
}

// 补款
export function supplyOrder(orderId, data) {
  return request({
    url: `/refund/${orderId}/v1`,
    method: "POST",
    data,
  });
}

/* 收款 */
export function orderPay(id) {
  return request({
    url: `/order/pay/${id}/v1`,
    method: 'PUT'
  })
}

/* 订单关闭 */
export function saleOrderClose(id, data) {
  return request({
    url: `/order/close/${id}/v1`,
    method: 'PUT',
    data
  })
}

// 销售订单  一键收款
export function saleOrderPayAll(params) {
  return request({
    url: "/order/pay_all/v1",
    params,
  }, {
    success: true,
    successMsg: $t('common.operatorOK')
  });
}

/* 退款 */
export function saleOrderRefund(data){
  return request({
    url: `/refund/apply/v1`,
    method: `POST`,
    data,
  }, {
    success: true,
    successMsg: $t('common.operatorOK')
  });
}

